const template = `
	<div class="items-list">
		<div
			v-for="item in items"
			class="list-item"
			:class="checkActive(item) ? 'list-item-active' : ''"
			@click="onClick(item)"
		>
			<slot name="item" :item="item">
				<router-link v-if="item.url" :to="item.url" class="list-item-inner">
					<i v-if="item.icon" :class="'fa fa-fw fa-' + item.icon"></i>
					{{ item.text }}
				</router-link>
				<span v-else class="list-item-inner">
					<i v-if="item.icon" :class="'fa fa-fw fa-' + item.icon"></i>
					{{ item.text }}
				</span>
			</slot>
		</div>
	</div>
`;

export default {
	template,
	props: ['value', 'items', 'close-parent', 'active-item', 'default-val'],
	methods: {
		onClick(item) {
			this.$emit('input', item.key);
			this.$emit('choose', {
				list: this.$el,
				item
			});

			if (this.closeParent && this.$parent.close) {
				this.$parent.close();
			}
		},
		checkActive(item) {
			if (item === this.activeItem) return true;

			let val = this.value;
			if (val === undefined) {
				val = this.defaultVal;
			}

			return val !== undefined && val === item.key;
		}
	}
}